<!-- My Account Basic Style -->
<div *ngIf="style == 'basic'" class="my-account-shell" [class.my-account-shell--open]="isMenuOpen">
  <app-ds-button
    type="button"
    tone="ghost"
    size="sm"
    class="header-icon-btn header-account-btn"
    [class.header-account-btn--avatar]="!!(isAuthenticated$ | async)"
    [ariaLabel]="'my_account' | translate"
    (pressed)="toggleAccountMenu($event)"
  >
    <!-- Unauthenticated -->
    <ng-container *ngIf="!(isAuthenticated$ | async)">
      <img src="assets/images/rhino.webp" class="header-account-rhino" alt="rhino" />
    </ng-container>

    <!-- Authenticated: profile image -->
    <ng-container *ngIf="isAuthenticated$ | async">
      <ng-container *ngIf="(streamer$ | async)?.image; else noStreamerImage">
        <img
          [src]="(streamer$ | async)?.image"
          class="header-account-avatar"
          alt="{{ 'auto_profile' | translate }}"
        />
      </ng-container>
      <ng-template #noStreamerImage>
        <ng-container
          *ngIf="
            (account$ | async)?.accountType === 'streamer' &&
            (account$ | async)?.streamer?.image;
            else showInitial
          "
        >
          <img
            [src]="(account$ | async)?.streamer?.image"
            class="header-account-avatar"
            alt="{{ 'auto_profile' | translate }}"
          />
        </ng-container>
        <ng-template #showInitial>
          <span class="header-account-initial">
            {{ (account$ | async)?.name?.charAt(0)?.toUpperCase() }}
          </span>
        </ng-template>
      </ng-template>
    </ng-container>
  </app-ds-button>
  <div
    class="onhover-div onhover-div-login"
    [class.onhover-div-login--open]="isMenuOpen"
    (mouseleave)="closeMenu()"
  >
    <ul class="user-box-name">
      <!-- unauthenticated -->
      <li class="product-box-contain" *ngIf="!(isAuthenticated$ | async)">
        <a [routerLink]="['/auth/login']" (click)="closeMenu()">
          <mat-icon class="menu-icon">login</mat-icon>
          {{ "sign_in" | translate }}
        </a>
      </li>
      <li class="product-box-contain" *ngIf="!(isAuthenticated$ | async)">
        <a [routerLink]="['/auth/creator-register']" (click)="closeMenu()">
          <mat-icon class="menu-icon">person_add</mat-icon>
          {{ "sign_up" | translate }}
        </a>
      </li>

      <!-- authenticated -->
      <li class="product-box-contain menu-user-header" *ngIf="isAuthenticated$ | async">
        <span class="menu-user-name">{{ (account$ | async)?.name }}</span>
        <span class="menu-user-label">{{ (account$ | async)?.email }}</span>
      </li>
      <li class="product-box-contain" *ngIf="isAuthenticated$ | async">
        <a routerLink="/account/profile" (click)="closeMenu()">
          <mat-icon class="menu-icon">manage_accounts</mat-icon>
          {{ "my_account" | translate }}
        </a>
      </li>
      <li class="product-box-contain menu-item--danger" *ngIf="isAuthenticated$ | async">
        <a href="javascript:void(0)" (click)="openLogoutDialog(); closeMenu()">
          <mat-icon class="menu-icon">logout</mat-icon>
          {{ "log_out" | translate }}
        </a>
      </li>
    </ul>
  </div>
</div>
